import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeleteKimThread = (matterId?: string, subsetId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async (threadId: string) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}`,
        fetchConfig,
      );
      if (!response.ok) {
        throw new Error('Deleting Kim thread failed');
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.KimThreads, { subsetId }]);
      },
    },
  );
};
